/* eslint-disable max-classes-per-file */
import { Link } from 'react-router-dom';
import type { Entities } from '@inwink/entities/entities';
import * as React from 'react';
import { AppTextLabel } from '@@services/i18nservice';
import { eventActions } from '@@services/eventservice';
import type { States } from '@@services/services';

import './appshellheader.less';
import { IPopoverManager, WithPopoverManager } from '@inwink/modals/popovermgr';
import { connectwith } from '@inwink/react-utils/decorators/connectwith';
import { AppShellMenuContext, IAppShellMenuState } from '@@components/appshellmenucontext';
import { AppCommandPromptContext, inwinkSearchCommand } from '@@components/appcommandprompt/appcommandpromptcontext';
import { AppShellHeaderSide } from './appshellheader.side';
//const AppShellHeaderSide = React.lazy(() => import('./appshellheader.side'));

export interface IAppShellHeaderProps {
    event: States.IEventState;
    user: States.IAppUserState;
    customer: States.ICustomerState;
    community: States.ICommunityState;
    i18n: States.i18nState;
    rights: States.IAppUserRights;
    sectiontitle?: string;
    pagetitle?: string;
    pagetitlePrefix?: string;
    pagesubtitle?: string;
    pageicon?: string;
    featurecode?: string;
    eventActions?: typeof eventActions;
    switchEvent?: any;
    visualstate: string[];
    breadcrumb?: States.IBreadcrumbWrapper[];
}

export interface IAppShellHeaderPartProps extends IAppShellHeaderProps {
    popovermgr: IPopoverManager;
    i18nHelper?: Entities.i18nHelper;
}

@connectwith((state: States.IAppState) => ({
    pagetitle: state.pages.title,
    pagetitlePrefix: state.pages.titlePrefix,
    pagesubtitle: state.pages.subtitle,
    pageicon: state.pages.pageicon,
    featurecode: state.pages.featurecode,
    breadcrumb: state.pages.breadcrumb
}))
export class AppShellHeader extends React.Component<IAppShellHeaderProps, any> {
    render() {
        return <AppShellMenuContext.Consumer>
            {(menustate) => <WithPopoverManager>
                {(popovermgr) => <AppShellHeaderContent {...this.props} popovermgr={popovermgr} menustate={menustate} />}
            </WithPopoverManager>}
        </AppShellMenuContext.Consumer>;
    }
}

export class AppShellHeaderContent extends React.Component<IAppShellHeaderPartProps & { menustate: IAppShellMenuState}, any> {
    toggleMenu = () => {
        this.props.menustate.toggleMenu();
    };

    render() {
        let title;
        let sectionTitle;
        if (this.props.breadcrumb && this.props.breadcrumb.length) {
            const lastbc = this.props.breadcrumb[this.props.breadcrumb.length - 1];
            if (lastbc.items.length) {
                const breadcrumbItem = [];
                lastbc.items.forEach((item, idx) => {
                    // let itemName = item.name;
                    // if (item.eventName) {
                    //     itemName = this.props.event?.detail?.title || this.props.event?.eventdetail?.title;
                    // } else if (item.communityName) {
                    //     itemName = this.props.community?.detail?.name;
                    // }
                    // let itemElt = <span key={"item" + idx}>{itemName}</span>;
                    // if (item.link) {
                    //     itemElt = <Link key={"item" + idx} to={item.link}>{itemName}</Link>
                    // }

                    // if (idx == lastbc.items.length - 1) {
                    //     itemElt
                    // }

                    breadcrumbItem.push(<BreadcrumbItem {...this.props}
                        key={"item" + idx} item={item}
                        isLast={idx == lastbc.items.length - 1}
                    />);
                    breadcrumbItem.push(<span key={"separator" + idx} className="separator">&gt;</span>);
                });
                breadcrumbItem.pop();
                sectionTitle = <div className="breadcrumb">{breadcrumbItem}</div>;
            }
        }

        if (this.props.pagetitle) {
            title = <div key={this.props.pagetitle} className="pagetitle-text">
                <div className="pagetitle">{this.props.pagetitlePrefix || ""}
                    <AppTextLabel i18n={this.props.pagetitle} />
                </div>
                {
                    (this.props.pagesubtitle)
                        ? <div className="pagesubtitle">{this.props.pagesubtitle}</div>
                        : null
                }
            </div>;
        } else {
            title = <div key="empty" className="pagetitle-text"><div className="pagetitle">&nbsp;</div></div>;
        }
        // const sectionTitle = <div className="eventName">
        //     {customerNav}
        //     {tenantNav}
        //     {sectionName}
        // </div>;

        let icon;
        return <div className="app-header">
            <div className="burger-menu" onClick={this.toggleMenu}>
                <div className="burger">
                    <div className="split1" />
                    <div className="split2" />
                    <div className="split3" />
                </div>
            </div>
            {icon}
            <div className="title">
                {sectionTitle}
                <div className="titlecontainer">
                    {title}
                </div>
            </div>
            <React.Suspense>
                <AppShellHeaderSide {...this.props} />
            </React.Suspense>
        </div>;
    }
}

function BreadcrumbItem(props: IAppShellHeaderPartProps & {key: string, item: States.IBreadcrumb, isLast?: boolean}) {
    const command = React.useContext(AppCommandPromptContext);
    let itemName = props.item.name;
    if (props.item.eventName) {
        itemName = props.event?.detail?.title || props.event?.eventdetail?.title;
    } else if (props.item.communityName) {
        itemName = props.community?.detail?.name;
    }

    if (props.item.link) {
        return <Link to={props.item.link}>{itemName}</Link>;
    }

    if (props.isLast) {
        return <span className="clickable" onClick={() => {
            command.triggerFor(inwinkSearchCommand);
        }}>{itemName}</span>;    
    }

    return <span>{itemName}</span>;
}